import * as React from "react";
import { createRoot } from "react-dom/client";
import { PropertyDetailsPage } from '@elo-ds/ui/dist/PropertyDetailsPage';

const renderPropertyDetails = () => {
    const container = document.getElementById('property-details-container');

    if (container) {
        const floatButtonText = container.getAttribute("data-floatButtonText");
        const hero = container.getAttribute("data-hero");
        const spaceIntroduction = container.getAttribute("data-space-introduction");
        const largeImage = container.getAttribute("data-large-image");
        const infoCard = container.getAttribute("data-infocard");
        const officeCardCarousel = container.getAttribute("data-officeCardCarousel");
        const similarOfficeCardCarousel = container.getAttribute("data-similarOfficeCardCarousel");
        const infoBanner = container.getAttribute("data-infoBanner");
        const contact = container.getAttribute("data-contact");
        const linkTo3DModel = container.getAttribute("data-linkTo3DModel");
        const autoPlayCardCarousel = container.getAttribute("data-autoPlayCardCarousel");
        const infoCardGridTwo = container.getAttribute("data-infoCardGridTwo");
        const googleMapApiKey = document.getElementById("current-sitecore-context").getAttribute("data-google-map-key");

        const socialLinks = container.getAttribute("data-SocialLinks");

        var spaceIntroductionJson = JSON.parse(spaceIntroduction);
        spaceIntroductionJson.googleMapsApiKey = googleMapApiKey;

        createRoot(container).render(
            <PropertyDetailsPage
                floatButtonText={floatButtonText}
                heroBanner={
                    JSON.parse(hero)
                }
                spaceIntroduction={
                    spaceIntroductionJson
                }
                largeImage={
                    JSON.parse(largeImage)
                }
                infoCardGrid={
                    JSON.parse(infoCard)
                }
                infoBanner={
                    JSON.parse(infoBanner)
                }
                contactBanner={
                    JSON.parse(contact)
                }
                officeCardCarousel={
                    JSON.parse(officeCardCarousel)
                }
                linkTo3DModel={linkTo3DModel}

                socialLinks={JSON.parse(socialLinks)}

                autoPlayCardCarousel={
                    JSON.parse(autoPlayCardCarousel)
                }
                infoCardGridTwo={
                    JSON.parse(infoCardGridTwo)
                }
            />
        );
    }
};
renderPropertyDetails();